import {
  Box,
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@material-ui/core";
import ExternalLinkButton from "src/components/Button/ExternalLinkButton";
import { formatAddress, numberWithCommas } from "src/services/utils";

const useStyle = makeStyles((theme) => ({
  firstCell: {
    position: "sticky",
    left: 0,
    zIndex: 1,
    backgroundColor: theme.palette.background.headerDefault,
  },
  firstBody: {
    position: "sticky",
    left: 0,
    zIndex: 1,
    backgroundColor: theme.palette.background.paper,
  },
}));

export default function TopUserTable({ data, pool }) {
  const cls = useStyle();

  return (
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell className={cls.firstCell} style={{ minWidth: "50px" }}>
              <Typography>Wallet address</Typography>
            </TableCell>
            <TableCell style={{ cursor: "pointer", minWidth: "50px" }}>
              <Typography>Number of transactions</Typography>
            </TableCell>
            <TableCell style={{ cursor: "pointer", minWidth: "50px" }}>
              <Typography>Total Value Lock (USD)</Typography>
            </TableCell>
            <TableCell style={{ cursor: "pointer", minWidth: "50px" }}>
              <Typography>Deposit Amount (USD)</Typography>
            </TableCell>
            <TableCell style={{ cursor: "pointer", minWidth: "50px" }}>
              <Typography>Borrow Amount (USD)</Typography>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((element, index) => {
            return (
              <TableRow key={index}>
                <TableCell className={cls.firstBody}>
                  <Box display="flex" justifyContent="flex-start" alignItems="center">
                    <Typography>{formatAddress(element.wallet)}</Typography>
                    <ExternalLinkButton hash={element.wallet} config={{ pool }} style={{ fontSize: "16px" }} />
                  </Box>
                </TableCell>
                <TableCell style={{ cursor: "pointer" }}>
                  <Typography>{numberWithCommas(element.numberOfTx)}</Typography>
                </TableCell>
                <TableCell style={{ cursor: "pointer" }}>
                  <Typography>{element.tvl > 0 ? `$${numberWithCommas(element.tvl)}` : "$0"}</Typography>
                </TableCell>
                <TableCell style={{ cursor: "pointer" }}>
                  <Typography>{`$${numberWithCommas(element.depositInUSD)}`}</Typography>
                </TableCell>
                <TableCell style={{ cursor: "pointer" }}>
                  <Typography>{`$${numberWithCommas(element.borrowInUSD)}`}</Typography>
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
